//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GroupPurchaseCountDown from '@/components/GroupPurchaseCountDown/index';
import Drip from 'drip';
import { groupBuyUrlReplace } from '@/utils/groupBuy';
export default {
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    GroupPurchaseCountDown: GroupPurchaseCountDown
  },
  data: function data() {
    return {
      countdownText: '',
      timer: null,
      currentTime: this.item.currentTime || 0,
      endTime: this.item.endTime || 0
    };
  },
  watch: {
    item: {
      handler: function handler(newVal) {
        this.currentTime = newVal.currentTime;
        this.endTime = newVal.endTime;
      },
      deep: true
    }
  },
  methods: {
    gotoGroupPurchase: function gotoGroupPurchase() {
      var _this$item;
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_um7pn5ro_mc',
        cid: 'c_movie_aq5xt2v5',
        groupbuying_id: (_this$item = this.item) === null || _this$item === void 0 ? void 0 : _this$item.dealId,
        needTag: true
      });
      Drip.redirect(groupBuyUrlReplace(this.item.detailLink));
    }
  },
  beforeDestroy: function beforeDestroy() {}
};